<template>
  <div :class="{'my-box': speaker==='my', 'other-box': speaker==='other'}">
    <div class="message"
      :style="{
        'background': color.balloonOtr + '!important',
        'color': autoColor(color.balloonOtr),
        'filter': shadowStyle()}">
      <div>{{formCheckBoxCreate(message)}}</div>
      <div class="checkbox-container">
        <div v-for="(p, i) in parameter" :key="i" v-if="messageEscape(p.item_message)!=''">
          <b-checkbox v-model="checkboxItems[messageEscape(p.item_message)]">{{messageEscape(p.item_message)}}</b-checkbox>
        </div>
      </div>
      <div class="field checkbox-button-wrapper">
        <button class="button" @click="checkboxSubmit(checkboxItems, isBot, 0)" v-if="!isNowButton()">送信</button>
      </div>
    </div>
  </div>
</template>

<script>
import hex2rgb from "@/functions/hex2rgb"
import alterReplace from '@/functions/alterStrReplace'
// 外部関数
import {
  autoColor,
  shadowStyle,
  formCheckBoxCreate,
  messageEscape,
  isNowButton
} from "@/functions/balloonFunc"

export default {
  name: "CheckBoxParts",
  props: ['message', 'speaker', 'color', 'parameter', 'lastIndex', 'logIndex', 'isBot', 'isDemo', 'roboArguments'],
  mounted () {
    for (let param of this.parameter) {
      this.dispParam.push({item_message: this.messageEscape(param.item_message)})
    }
    this.checkboxFlgSet()
  },
  methods: {
    autoColor (c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    shadowStyle (t) {
      return shadowStyle(t)
    },
    formCheckBoxCreate (m) {
      return formCheckBoxCreate(m, this.roboArguments)
    },
    messageEscape (m) {
      return messageEscape(m, this.roboArguments)
    },
    isNowButton () {
      return isNowButton(this.logIndex, this.lastIndex, this.speaker)
    },
    checkboxSubmit (checkboxItems, isBot, idx) {
      let flg = false
      for (let p of this.dispParam) {
        p.item_message = this.messageEscape(p.item_message)
        if (checkboxItems[alterReplace(p.item_message, true)]) flg = true
      }
      if (!flg) {
        alert('いずれかの項目にチェックをお願いいたします。')
      } else {
        this.$emit('checkboxSubmit', checkboxItems, isBot, idx)
      }
    },
    checkboxFlgSet () {
      for (let p of this.dispParam) {
        p.item_message = this.messageEscape(p.item_message)
        this.checkboxItems[p.item_message] = false
      } 
    }
  },
  computed: {
  },
  data () {
    return {
      checkboxItems: {},
      dispParam: [],
    }
  }
};
</script>

<style scoped>
.message {
  text-align: left;
  padding: 16px;
  width: auto;
  max-width: -webkit-fill-available;
  word-wrap: break-word;
  border-radius: 8px;
  font-size: smaller;
  white-space: pre-wrap;
  transition: 0.7s;
}
.my-box {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}
.other-box {
  display: flex;
  justify-content: flex-start;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/BalloonParts/CheckBoxParts.vue